import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import { Swiper } from '@webikon/webentor-core/_slider';

const productGallerySwiper = new Swiper('.js-product-gallery-thumbs', {
  loop: false,
  spaceBetween: 12,
  slidesPerView: 3.3,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // when window width is >= 768 (md)
    1024: {
      slidesPerView: 4,
      spaceBetween: 32,
    },
  },
});

new Swiper('.js-product-gallery', {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 10,
  loopAddBlankSlides: false,
  allowTouchMove: false,
  noSwiping: true,
  thumbs: {
    swiper: productGallerySwiper,
  },
});

const lightboxesProduct = document.querySelectorAll(
  '.lightgallery-product-gallery',
);
if (lightboxesProduct.length > 0) {
  lightboxesProduct.forEach((element) => {
    lightGallery(element, {
      plugins: [lgThumbnail, lgZoom],
      selector: '.lightgallery-product-item',
      download: false,
      controls: true,
      mobileSettings: {
        controls: false,
        showCloseIcon: true,
        download: false,
      },
    });
  });
}
